import React, {memo} from 'react';

import {GuestPicker} from '@homeaway/react-guest-picker';

// GuestPicker.whyDidYouRender = true;

import {useComponent} from './hooks/useComponent';

import './SearchGuestsDetailsInputField.less';
import '../SearchGuestsPicker/SearchGuestsPicker.less';

const SearchGuestsDetailsInputField = memo(function SearchGuestsDetailsInputField() {
    const {
        className,
        actionLocation,
        adultsCount,
        adultsLabel,
        adultsMax,
        adultsMin,
        ageData,
        ageOptions,
        ageSelectSubtitle,
        ageSelectTitle,
        applyButtonLabel,
        bedroomsCount,
        bedroomsLabel,
        bedroomsMax,
        bedroomsMin,
        centered,
        childrenCount,
        childrenLabel,
        childrenMax,
        childrenMin,
        clearButtonLabel,
        continueButtonLabel,
        disableButton,
        disableTextInput,
        fadeOut,
        fadeOutDuration,
        formSuffixElement,
        guestLabel,
        id,
        inputIcon,
        isAriaRoleExperimentEnabled,
        isMobile,
        isOpen,
        label,
        modalTitle,
        name,
        onAgeChange,
        onChange,
        onClear,
        onClose,
        onExit,
        onOpen,
        petIncluded,
        petLabel,
        petNoLabel,
        petYesLabel,
        pickerClassName,
        placement,
        positionIconRight,
        readOnly,
        showAgeRanges,
        showAgeSelect,
        showBedroomsOption,
        showClearButton,
        showContinue,
        showPetOption,
        wdioPrefix
    } = useComponent();

    return (
        <div className={className}>
            <GuestPicker
                actionLocation={actionLocation}
                adultsCount={adultsCount}
                adultsLabel={adultsLabel}
                adultsMax={adultsMax}
                adultsMin={adultsMin}
                ageData={ageData}
                ageOptions={ageOptions}
                ageSelectSubtitle={ageSelectSubtitle}
                ageSelectTitle={ageSelectTitle}
                applyButtonLabel={applyButtonLabel}
                bedroomsCount={bedroomsCount}
                bedroomsLabel={bedroomsLabel}
                bedroomsMax={bedroomsMax}
                bedroomsMin={bedroomsMin}
                centered={centered}
                childrenCount={childrenCount}
                childrenLabel={childrenLabel}
                childrenMax={childrenMax}
                childrenMin={childrenMin}
                className={pickerClassName}
                clearButtonLabel={clearButtonLabel}
                continueButtonLabel={continueButtonLabel}
                disableButton={disableButton}
                disableTextInput={disableTextInput}
                fadeOut={fadeOut}
                fadeOutDuration={fadeOutDuration}
                formSuffixElement={formSuffixElement}
                guestLabel={guestLabel}
                id={id}
                inputIcon={inputIcon}
                isAriaRoleExperimentEnabled={isAriaRoleExperimentEnabled}
                isMobile={isMobile}
                isOpen={isOpen}
                label={label}
                modalTitle={modalTitle}
                name={name}
                onAgeChange={onAgeChange}
                onChange={onChange}
                onClear={onClear}
                onClose={onClose}
                onExit={onExit}
                onOpen={onOpen}
                petIncluded={petIncluded}
                petLabel={petLabel}
                petNoLabel={petNoLabel}
                petYesLabel={petYesLabel}
                placement={placement}
                positionIconRight={positionIconRight}
                readOnly={readOnly}
                showAgeRanges={showAgeRanges}
                showAgeSelect={showAgeSelect}
                showBedroomsOption={showBedroomsOption}
                showClearButton={showClearButton}
                showContinue={showContinue}
                showPetOption={showPetOption}
                wdioPrefix={wdioPrefix}
            />
        </div>
    );
});

SearchGuestsDetailsInputField.whyDidYouRender = true;

export {SearchGuestsDetailsInputField};
